import styled from 'styled-components';

export const GaugeChartContainer = styled.div`
  position: relative;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const GaugeChartWrapper = styled.div<{ size: number }>`
  position: relative;
  width: ${(props) => props.size}px;
  height: ${(props) => props.size}px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const GaugeChartLabel = styled.div<{ secondary?: boolean }>`
  position: absolute;
  top: ${(props) => (props.secondary ? 'auto' : '50%')};
  bottom: ${(props) => (props.secondary ? '5px' : 'auto')};
  left: 50%;
  transform: ${(props) =>
    props.secondary ? 'translate(-50%, 0)' : 'translate(-50%, -50%)'};
  font-size: ${(props) => (props.secondary ? '12px' : '30px')};
  font-weight: ${(props) => (props.secondary ? 'normal' : 'bold')};
  color: #333;
  text-align: center;
  white-space: nowrap;
  margin-top: ${(props) => (props.secondary ? '0' : '-20px')};

  tspan {
    font-size: ${(props) => (props.secondary ? '10px' : '16px')};
  }
`;
